// user-request-form.utils.js
// ฟังก์ชัน pure ล้วน ๆ ที่ไม่พึ่ง React / service / axios
// แยกออกมาเพื่อให้เทสต์ import ได้โดยไม่ลากทั้งฟอร์มเข้ามา

export const DAY_CODE = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

// ── ดึง "HH:MM" ออกจาก ISO string (ต้องมีตัว "T" คั่นเท่านั้น) ──
export const extractTimeHHMM = (isoStr) => {
  if (!isoStr) return "";
  const match = isoStr.match(/T(\d{2}):(\d{2})/);
  return match ? `${match[1]}:${match[2]}` : "";
};

// ── "อื่นๆ" (จุดเริ่มต้นที่ผู้ใช้กรอกชื่อเอง) ──
// ── backend เก็บ origin_id_building = 0 (เหมือน "ว่าง") แยกออกจากกันด้วยการเช็คว่ามี origin_building_name เป็นชื่อจริง (ไม่ใช่ "-") ──
// ── จุดเริ่มต้น "อื่นๆ": ไม่มี building id จริง (รองรับทั้ง 0 ของใหม่ และ -1 ของเก่า) + มีชื่อจริง ──
export const isOtherPickupDetail = (detail) =>
  !(Number(detail?.origin_id_building) > 0) &&
  !!detail?.origin_building_name &&
  detail.origin_building_name !== "-";

// ── อาคารปลายทาง "อื่นๆ" (เฉพาะ service type 1 = ส่งเอกสาร) ──
// ── backend เก็บ destination_id_building = 0 (เหมือน "ว่าง") แยกด้วยการเช็คว่ามี destination_name เป็นชื่อจริง ──
export const isOtherBuildingDetail = (detail) =>
  Number(detail?.id_service_type) === 1 &&
  !(Number(detail?.destination_id_building) > 0) &&
  !!detail?.destination_name;

// ── สาขา provider เป็น "อื่นๆ" หรือไม่ (ค่า branch = 0 หรือ -1) ──
export const isOtherProviderBranch = (idServiceType, destinationIdProviderBranch) => {
  const val = Number(destinationIdProviderBranch);
  return val === 0 || val === -1;
};

// ── format วันที่เป็น d/m/yyyy (พ.ศ.ตาม input) ──
export const formatDateTH = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
};

// ── แปลง "d/m/y" → "yyyy-mm-dd" ──
export const dmyToISO = (str) => {
  if (!str) return "";
  const [d, m, y] = String(str).split("/").map(Number);
  if (!d || !m || !y) return "";
  return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
};

// ── รวมวันที่ replacement (object) ให้เป็น string คั่นด้วย "," ──
export const buildReplacementsString = (replacements) => {
  if (!replacements) return "";
  return Object.values(replacements)
    .filter(Boolean)
    .map(dmyToISO)
    .join(",");
};
